import { fetcher } from '@/api/fetcher/fetcher'

function useCalendarInit() {
  return fetcher({
    url: `/calendar/init`,
    options: { method: 'GET' },
  })
}
export { useCalendarInit }
